import { useSelector } from 'react-redux';
import { Icon, Txt } from '@vst/beam';
import { ShoppingCart } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import { Collapsible } from '@app/components/Collapsible';
import { selectCurrentEasyCareProduct, selectCurrentShopAddon } from '@app/redux/addOns';

import AddonCart from '../AddonCart';
import { getPriceAndDiscount } from '../../utils';
import { CollapsibleCartProps } from '../../types';

import styles from '../../styles/cart.module.scss';

const CollapsibleCart = (props: CollapsibleCartProps) => {
  const { t } = useTranslation('ShopAddons');
  const currentShopAddon = useSelector(selectCurrentShopAddon);
  const chosenEasyCareProduct = useSelector(selectCurrentEasyCareProduct);

  if (!currentShopAddon) {
    return null;
  }

  const { price } = getPriceAndDiscount(currentShopAddon);

  return (
    <Collapsible
      dataCy="collapsible-cart"
      classNames={{ summary: styles['collapsibleSummaryBackground'] }}
      summary={
        <div className={styles['collapsibleSummaryContent']}>
          <Icon data-cy="shopping-cart-icon" icon={ShoppingCart} size={24} color="gray_600" />
          {currentShopAddon?.is_grouped_product && !chosenEasyCareProduct ? (
            <Txt variant="tinyRegular" color="subtle">
              {t('groupedEasyCare.emptyCart')}
            </Txt>
          ) : (
            <>
              <Txt variant="smallRegular">{t('cart.monthly')}</Txt>
              <Txt variant="smallBold">{price === 0 ? t('cart.free') : t('cart.monthlyPrice', { price })}</Txt>
            </>
          )}
        </div>
      }
      content={
        <div className={styles['collapsibleCartDetails']}>
          <AddonCart
            {...props}
            displayTC={props.displayTC}
            addon={currentShopAddon}
            selectedEasyCareProduct={chosenEasyCareProduct}
            isLastStep={props.isLastStep}
          />
        </div>
      }
    />
  );
};

export default CollapsibleCart;
